import React, { useState, useEffect } from 'react';
import { ResetPassword as ResetPasswordComponent } from '../components/ResetPassword';
import { supabase } from '../lib/supabase';

export default function ResetPasswordPage() {
  const [isPasswordRecovery, setIsPasswordRecovery] = useState(false);
  
  useEffect(() => {
    // Subscribe to auth state changes to detect password recovery event
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') {
        setIsPasswordRecovery(true);
      }
    });

    // Unsubscribe on cleanup
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <div>
      {isPasswordRecovery ? (
        <ResetPasswordComponent />
      ) : (
        <div className="min-h-screen brand-gradient flex items-center justify-center p-4">
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg max-w-md w-full text-center">
            <h1 className="text-2xl sm:text-3xl font-bold font-display text-brand-secondary mb-4">
              Reset Password
            </h1>
            <p className="text-lg mb-6 text-brand-primary">
              Waiting for password recovery confirmation...
            </p>
            <p className="text-sm text-gray-600">
              Please click the reset password link in your email to continue.
            </p>
          </div>
        </div>
      )}
    </div>
  );
} 